export default __webpack_public_path__ + "static/media/frozen.576f09bc.svg";